import React from "react";
import { useHistory } from "react-router-dom";

const FavoriteCard = ({ image, id, location, handleDeleteFavorite }) => {

    const history = useHistory()

    const handleDetails = () => {
        history.push(`/photo/${id}`)
    }

    return(
        <div className="main-container">
            <div className="user-photo-card">
                <div id="user-image">
                    <img src={image} onClick={handleDetails} alt="user-img" className="user-image"/>
                </div>
                <p>{location}</p>
            </div>
        </div>
    )
}

export default FavoriteCard;